<div class="col-md-12 text-center">
  <h5 class="text-primary pb-2">{{ headingText }}</h5>
</div>
<div class="xray-items">
  
  <div class="text-danger heading"
       *ngIf="
      activeStudy?.isCompleteXrayTemplate &&
        xraysMediaGroups.uploadXrayCount != xraysMediaGroups.requiredCategoriesCount ;
      else successMatch
    ">
    All images are required
    <span *ngIf="viewMode === ViewMode.DRAFT" class="badge bg-danger mx-1">{{ xraysMediaGroups.uploadXrayCount }} of {{ xraysMediaGroups.requiredCategoriesCount }}</span>
  </div>

  <ng-template #successMatch>
    <div class="text-success heading">
      Successfully Matched Images
      <span *ngIf="viewMode === ViewMode.DRAFT" class="badge bg-success">{{ xraysMediaGroups.uploadXrayCount }} of {{ xraysMediaGroups.requiredCategoriesCount  }}</span>
    </div>
  </ng-template>

  <section *ngIf="viewMode === ViewMode.DRAFT;"
           class="xray-item-section">
    <div *ngFor="
        let mediaGroup of xraysMediaGroups.displayMediaGroups | filterActiveGroupsPipe;
        trackBy: trackByGroup
      ">
      <div class="row xray-item-with-top-line" [hidden]="!mediaGroup.name">
        <div class="col-4 col-sm-4 text-left">
          <span class="position-left">LEFT</span>
        </div>
        <div class="col-4 col-sm-4 text-center">
          <span class="position-center"> {{ mediaGroup.name }}</span>
        </div>
        <div class="col-4 col-sm-4 text-end">
          <span class="position-right">RIGHT</span>
        </div>
      </div>
      <div class="row xray-item-with-vertical-line">
        <div class="col-lg-6">
          <div class="xray-data-left">
            <div class="row gutters-0">
              <ng-container *ngFor="let category of mediaGroup.mediaCategories | withStudyFile : null : false; trackBy: trackByCategory">
                <ng-container  *ngIf="category.studyFiles.length > 0">
                  <div class="col-lg-4 col-md-6" *ngFor="let file of category.studyFiles">
                    <app-xray-item [studyFile]="file"
                                   [mediaCategory]="category.category"
                                   [mediaCategories]="mediaCategories"
                                   [mediaGroups]="mediaGroups"
                                   [uploadDisabled]="checkForCategoryIdUpload(category.category.id)"
                                   (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                   (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                                   (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                                   (uploadFiles)="uploadFiles($event)"
                                   (viewImage)="viewImage($event)"></app-xray-item>
                  </div>

                </ng-container>
              </ng-container>

              <ng-container *ngFor="let category of mediaGroup.mediaCategories | withStudyFile : null : false; trackBy: trackByCategory">
                <div class="col-lg-4 col-md-6" *ngIf="category.studyFiles.length == 0">
                 
                    <app-xray-item 
                                   [mediaCategory]="category.category"
                                   [mediaCategories]="mediaCategories"
                                   [mediaGroups]="mediaGroups"
                                   [uploadDisabled]="checkForCategoryIdUpload(category.category.id)"
                                   (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                   (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                                   (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                                   (uploadFiles)="uploadFiles($event)"
                                   (viewImage)="viewImage($event)"></app-xray-item>
                 

                </div>
              </ng-container>

            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="xray-data-right">
            <div class="row justify-content-end gutters-0">

              <ng-container *ngFor="let category of mediaGroup.mediaCategories | withStudyFile : null : true; trackBy: trackByCategory">
                <ng-container  *ngIf="category.studyFiles.length > 0">
                  <div class="col-lg-4 col-md-6" *ngFor="let file of category.studyFiles">
                    <app-xray-item [studyFile]="file"
                                   [mediaCategory]="category.category"
                                   [mediaCategories]="mediaCategories"
                                   [mediaGroups]="mediaGroups"
                                   [uploadDisabled]="checkForCategoryIdUpload(category.category.id)"
                                   (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                   (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                                   (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                                   (uploadFiles)="uploadFiles($event)"
                                   (viewImage)="viewImage($event)"></app-xray-item>
                  </div>

                </ng-container>
              </ng-container>

              <ng-container *ngFor="let category of mediaGroup.mediaCategories | withStudyFile : null : true; trackBy: trackByCategory">
                <div class="col-lg-4 col-md-6" *ngIf="category.studyFiles.length == 0">

                  <app-xray-item [mediaCategory]="category.category"
                                 [mediaCategories]="mediaCategories"
                                 [mediaGroups]="mediaGroups"
                                 [uploadDisabled]="checkForCategoryIdUpload(category.category.id)"
                                 (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                 (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                                 (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                                 (uploadFiles)="uploadFiles($event)"
                                 (viewImage)="viewImage($event)"></app-xray-item>


                </div>
              </ng-container>

  
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>
